export default __webpack_public_path__ + "assets/icons/cancel.0f69e0ac.svg";